/**
 * @copyright 2026 @ DigiNet
 * @author ANHTAI
 * @create 2026/08/10 09:15
 * @update 2026/08/10 09:15
 */

import { Column, Summary, TotalItem } from "devextreme-react/data-grid";
import { Col, DatePicker, Dropdown, Row, Checkbox, Button, TextInput } from 'diginet-core-ui/components';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { bindActionCreators } from "redux";
import * as W14F1020Actions from "../../../actions/w14/w14F1020/w14F1020-actions";
import * as W14F1021Actions from "../../../actions/w14/w14F1021/w14F1021-actions";
import Config from "../../../config";
import GridContainer from "../../common/grid-container/grid-container";
import ActionToolbar from "../../common/tool-bar/action-toolbar";
import { Loading } from "../../common/loading/loadingCore";
import ButtonExport from "../../common/button/button-export";
import MForm from "../../common/form/form";

const FormID = 'W14F1021';
const arrRequiredField = ['DateFrom', 'DateTo'];

const initialDataMaster = {
    DateFrom: null,
    DateTo: null,
    GroupSalesID: '',
    StatusName: '',
    StatusColor: '',
    CommissionID: '',
    ObjectID: "",
};

const W14F1021 = (props) => {
    const { location } = props || {};
    const [formLoading, setFormLoading] = useState(false);
    const [cboGroupSaleLoading, setCboGroupSaleLoading] = useState(false);
    const [cboObjectLoading, setCboObjectLoading] = useState(false);
    const [isCheckedAll, setIsCheckedAll] = useState(0);
    const [dataMaster, setDataMaster] = useState({ ...initialDataMaster });
    const [error, setError] = useState({});
    const [dataGrid, setDataGrid] = useState([]);
    const [dataCboGroupSales, setDataCboGroupSales] = useState([]);
    const [dataCboObject, setDataCboObject] = useState([]);
    const [mode, setMode] = useState(location?.state?.mode || 'view');

    const gridDetailRef = useRef(null);

    const readOnly = mode === 'view';

    useEffect(() => {
        if (!getInfo()) return;
        loadCboGroupSales();
        if (mode !== 'add') {
            loadForm('LoadMaster');
            loadForm('LoadDetail');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getInfo = (flag) => {
        if (location?.state) {
            const { mode = 'view', CommissionID = '' } = location?.state || {};
            return { mode, CommissionID }
        } else if (flag) {
            browserHistory.push(Config.env.url + "/W14F1020");
            return null;
        }
        return false;
    };

    const loadCboGroupSales = () => {
        setCboGroupSaleLoading(true);
        props.W14F1020Actions.loadComboGeneral(getParamGeneral('GroupSales'), (error, data) => {
            setCboGroupSaleLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboGroupSales(data);
            }
        });
    };

    const loadCboObject = (groupSales) => {
        setCboObjectLoading(true);
        props.W14F1021Actions.loadCboObject(getParamGeneral('LoadComboObject', {GroupSalesID: groupSales}), (error, data) => {
            setCboObjectLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) setDataCboObject(data);
        });
    };

    const loadForm = (type, dataPlus = {}) => {
        const params = getParamGeneral(type, dataPlus);
        setFormLoading(true);
        props.W14F1021Actions.loadForm(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (type === 'LoadMaster') setDataMaster({ ...initialDataMaster, ...data?.[0] });
                if (type === 'LoadDetail') {
                    if (data.every(item => !!item?.Choose)) setIsCheckedAll(1);
                    setDataGrid(data || []);
                }
            }
        });
    };

    const onConfirm = (type) => {
        if (checkRequired()) return;
        setFormLoading(true);
        props.W14F1021Actions.onConfirm(getParamGeneral(type), (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const { Message, Status, CommissionID } = data || {};
                let confirmMessage = type === 'confirm' ? Config.lang('Xac_nhan') : Config.lang('Huy_xac_nhan');
                if (data?.Status === 0) {
                    loadForm('LoadMaster', { CommissionID });
                    loadForm('LoadDetail', { CommissionID });
                    Config.notify.show('success', Message || `${confirmMessage} ${Config.lang('Thanh_cong').toLocaleLowerCase()}`, 2000);
                }
                else if (Status === 1 && Message) Config.popupCore.show('WARNING', Message);
            }
        });
    };

    const onCalculateCommission = () => {
        if (checkRequired()) return;
        setFormLoading(true);
        props.W14F1021Actions.onCalculateCommission(getParamGeneral('CalculateCommission'), (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataGrid(data);
            }
        });
    };

    const checkValidateMaster = (arrName) => {
        if (Config.isEmpty(arrName)) return;
        return arrName.map(item => {
            let val = dataMaster[item];
            return {
                name: item,
                rules: ["isRequired"],
                value: val
            }
        });
    };

    const checkRequired = () => {
        let status = false;
        const resultValidate = checkValidateMaster(arrRequiredField);
        const validateFrom = MForm.formValidation(resultValidate);
        if (Object.keys(validateFrom).length > 0) {
            setError(validateFrom, true);
            status = true;
        }
        return status;
    };

    const onSave = async () => {
        let detail = dataGrid;
        if (checkRequired()) return;
        await gridDetailRef.current.instance.saveEditData();
        detail = gridDetailRef.current.instance.option('dataSource') || [];
        const params = getParamGeneral('Save', { detail });
        setFormLoading(true);
        props.W14F1021Actions.onSave(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const { Status, CommissionID, Message } = data || {};
                if (Status === 0) {
                    Config.notify.show('success', Config.lang('Luu_thanh_cong'), 2000);
                    if (CommissionID) {
                        browserHistory.replace({
                            pathname: 'W14F1021',
                            state: { ...location?.state, CommissionID }
                        });
                        setTimeout(() => {
                            loadForm('LoadMaster', { CommissionID });
                            loadForm('LoadDetail', { CommissionID });
                        }, 300);
                        setMode('view');
                    }
                } else if (Status === 1 && Message) Config.popupCore.show('WARNING', Message);
            }
        });
    };

    const getParamGeneral = (type, data = {}) => {
        const { CommissionID } = getInfo();
        const { GroupSalesID } = dataMaster || {};
        let params = {
            FormID,
            DateFrom: null,
            DateTo: null,
            CommissionID,
            GroupSalesID,
            DataTypeID: type,
        };
        switch (type) {
            case 'LoadMaster':
            case 'LoadDetail':
                params = { ...params, ...data };
                break;
            case 'Save':
            case 'Confirm':
            case 'UnConfirm':
            case 'CalculateCommission':
                params = { ...params, ...dataMaster, ...data };
                break;
            case 'LoadComboObject':
                params = { ...params, ...dataMaster, ...data };
                break;
            default:
                params.CommissionID = '';
                break;
        }
        return params;
    };

    const onChange = (keyName, e) => {
        if (!e || !keyName) return;
        let value = e?.value ?? e?.target?.value ?? '';
        if (Config.isEmpty(value) && ['DateFrom', 'DateTo'].includes(keyName)) value = null;
        let objPlus = { ...dataMaster, [keyName]: value };
        if (keyName === 'IsDate') objPlus.IsPeriod = +!value;
        else if (keyName === 'IsPeriod') objPlus.IsDate = +!value;
        else if (keyName === "GroupSalesID") loadCboObject(value);
        setDataMaster(objPlus);
        if (error?.[keyName] && !Config.isEmpty(value)) setError({ [keyName]: '' });
    };

    const renderCheckbox = (e) => {
        const { rowType } = e || {};
        const value = rowType === 'header' ? isCheckedAll : e?.value;
        return <Checkbox
            style={{ margin: 'auto' }}
            checked={!!value}
            disabled={mode === 'view'}
            onChange={(c) => {
                const val = +c?.value
                if (rowType === 'header') {
                    const data = dataGrid.map(item => ({ ...item, Choose: val }));
                    setDataGrid(data);
                    setIsCheckedAll(val);
                } else {
                    e.component.cellValue(e.rowIndex, 'Choose', val);
                    e.component.saveEditData();
                    if (!!val) {
                        const dataSource = e.component.option('dataSource');
                        const dataSourceChecked = dataSource.filter(item => item?.Choose);
                        if (dataSource.length === dataSourceChecked.length) setIsCheckedAll(1); // Check ALL
                    } else setIsCheckedAll(0); // UnCheck All
                }
            }}
        />;
    };

    const renderGrid = useMemo(() => {
        const dataSource = dataGrid.map((item, idx) => ({ ...item, STT: idx }));
        return (
            <GridContainer
                reference={ref => gridDetailRef.current = ref}
                dataSource={dataSource}
                typePaging={'normal'}
                keyExpr={'STT'}
                pagerFullScreen={false}
                itemPerPage={50}
                listPerPage={[50, 100, 150, 200]}
                elementAttr={{ style: `max-height: 720px; min-height: 320px` }}
            >
                <Column
                    width={80}
                    dataType={'number'}
                    alignment={'center'}
                    allowFiltering={false}
                    allowSorting={false}
                    dataField={'Choose'}
                    headerCellRender={renderCheckbox}
                    cellRender={renderCheckbox}
                />
                <Column
                    width={320}
                    dataField={'CommissionRecipient'}
                    caption={Config.lang('Nguoi_huong')}
                />
                <Column
                    width={260}
                    dataField={'VoucherNum'}
                    caption={Config.lang('So_don_hang')}
                />
                <Column
                    width={260}
                    dataField={'StatusSO'}
                    caption={Config.lang('Trang_thai_don')}
                />
                <Column
                    width={260}
                    dataField={'StatusPaymentSO'}
                    caption={Config.lang('Trang_thai_thanh_toan')}
                />
                <Column
                    width={180}
                    dataField={'VoucherDate'}
                    alignment={'center'}
                    dataType={'date'}
                    format={'dd/MM/yyyy'}
                    caption={Config.lang("Ngay_don_hang")}
                />
                <Column
                    width={320}
                    dataField={'PolicyID'}
                    caption={Config.lang('Ma_chinh_sach')}
                />
                <Column
                    width={200}
                    dataType={'number'}
                    dataField={'AmountCollaborator'}
                    caption={`${Config.lang('Thanh_tien')}(CTV)`}
                    calculateDisplayValue={(e) => Config.numberFormat(e?.AmountCollaborator, 8)}
                />
                <Column
                    width={200}
                    dataType={'number'}
                    dataField={'AmountBranch'}
                    caption={`${Config.lang('Thanh_tien')}(CN/PGD)`}
                    calculateDisplayValue={(e) => Config.numberFormat(e?.AmountBranch, 8)}
                />
                <Summary>
                    <TotalItem
                        column={'AmountCollaborator'} // Thanh tien
                        summaryType={'sum'}
                        displayFormat={"{0}"}
                        valueFormat={(e) => Config.numberFormat(e, 8)}
                    />
                    <TotalItem
                        column={'AmountBranch'} // Thanh tien
                        summaryType={'sum'}
                        displayFormat={"{0}"}
                        valueFormat={(e) => Config.numberFormat(e, 8)}
                    />
                </Summary>
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGrid, formLoading, mode, isCheckedAll]);

    const onBack = () => {
        browserHistory.goBack();
    };

    const getParamExport = () => {
        const params = [
            { "id": "UserID", "type": "VarChar", "value": Config.profile.UserID },
            { "id": "Language", "type": "VarChar", "value": Config.language || '84' },
            { "id": "DivisionID", "type": "VarChar", "value": Config.profile.DivisionID },
            { "id": "ReportTypeID", "type": "VarChar", "value": FormID },
        ];
        for (const property in dataMaster) {
            let type = 'NVarChar';
            if (['number', 'null'].includes(Config.typeOf(dataMaster[property]))) type = /from|to/i.test(property) ? 'DATETIME' : 'INT';
            else if (/from|to/i.test(property)) type = 'DATETIME';
            params.push({ "id": property, "type": type, "value": dataMaster[property] })
        }
        return params;
    };

    if (!getInfo(true)) return null;
    return (
        <div className={'page-container-new'} style={{ height: '100vh' }}>
            <Loading visible={formLoading} />
            <ActionToolbar title={Config.lang('Hoa_hong_ban_hang')} onBack={onBack}>
                <div className={'wrap align-center align-between full_w'}>
                    <div className={'wrap align-center align-between'}>
                        <Button
                            color={'info'}
                            startIcon={"Save"}
                            viewType={"text"}
                            label={Config.lang('Luu')}
                            disabled={readOnly}
                            onClick={() => onSave()}
                        />
                        <Button
                            color={'warning'}
                            startIcon={"Edit"}
                            viewType={"text"}
                            className={`${mode === 'add' ? 'hide' : ''} mgl1x`}
                            label={Config.lang('Sua')}
                            disabled={mode !== "view"}
                            onClick={() => setMode('edit')}
                        />
                        <ButtonExport
                            isViewPDF
                            isPreview
                            onlyShowPopup
                            isCoreUI
                            className={'mgl1x'}
                            disabled={mode === 'add'}
                            name={Config.lang('In1')}
                            transTypeID={'Export_Quotation'}
                            reportTypeID={FormID}
                            param={getParamExport()}
                            FormID={FormID}
                        />
                    </div>
                    <div>
                        <Button
                            color={'success'}
                            startIcon={'Approval'}
                            viewType={"text"}
                            label={Config.lang('Xac_nhan')}
                            disabled={!(dataMaster?.Status === 0 && mode === 'view')}
                            onClick={() => onConfirm('Confirm')}
                        />
                        <Button
                            color={'danger'}
                            startIcon={'Deny'}
                            viewType={"text"}
                            className={'mgl1x'}
                            label={Config.lang('Huy_xac_nhan')}
                            disabled={!(dataMaster?.Status === 1 && mode === 'view')}
                            onClick={() => onConfirm('UnConfirm')}
                        />
                    </div>
                </div>
            </ActionToolbar>
            <Row className={'mgt0'}>
                <Col xs={12} sm={6} md={4} lg={2.5}>
                    <Dropdown
                        readOnly={readOnly}
                        viewType={'outlined'}
                        valueExpr={'GroupSalesID'}
                        displayExpr={'GroupSalesName'}
                        label={Config.lang('Nhom_doi_tuong')}
                        loading={cboGroupSaleLoading}
                        dataSource={dataCboGroupSales}
                        value={dataMaster?.GroupSalesID}
                        onChange={e => onChange('GroupSalesID', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={4} lg={2.5}>
                    <Dropdown
                        readOnly={readOnly}
                        viewType={'outlined'}
                        valueExpr={'ObjectID'}
                        displayExpr={'ObjectName'}
                        label={Config.lang('Doi_tuong')}
                        loading={cboObjectLoading}
                        dataSource={dataCboObject}
                        value={dataMaster?.ObjectID}
                        onChange={e => onChange('ObjectID', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={4} lg={2.5}>
                    <DatePicker
                        clearAble
                        required
                        viewType={'outlined'}
                        displayFormat={"DD/MM/YYYY"}
                        readOnly={readOnly}
                        label={Config.lang('Thoi_gian_tu')}
                        max={dataMaster?.DateTo}
                        value={dataMaster?.DateFrom}
                        error={error?.DateFrom}
                        onChange={e => onChange('DateFrom', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={4} lg={2.5}>
                    <DatePicker
                        clearAble
                        required
                        viewType={'outlined'}
                        displayFormat={"DD/MM/YYYY"}
                        readOnly={readOnly}
                        label={Config.lang('Thoi_gian_den')}
                        min={dataMaster?.DateFrom}
                        value={dataMaster?.DateTo}
                        error={error?.DateTo}
                        onChange={e => onChange('DateTo', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={4} lg={2.5}>
                    <TextInput
                        readOnly
                        viewType={'outlined'}
                        label={Config.lang('Trang_thai')}
                        value={dataMaster?.StatusName}
                        inputStyle={{ color: dataMaster?.StatusColor }}
                    />
                </Col>
                <Col xs={12} sm={6} md={4} lg={2} verticalAlign={'end'}>
                    <Button
                        disabled={readOnly}
                        viewType={'outlined'}
                        color={'primary'}
                        startIcon={'PercentDiscount'}
                        label={Config.lang('Tinh_hoa_hong')}
                        onClick={onCalculateCommission}
                    />
                </Col>
                <Col xs={12}>{renderGrid}</Col>
            </Row>
        </div>
    );
}

export default connect(null, (dispatch) => ({
    W14F1020Actions: bindActionCreators(W14F1020Actions, dispatch),
    W14F1021Actions: bindActionCreators(W14F1021Actions, dispatch),
}))(W14F1021);


